import React, { useEffect, useState } from "react";
import { CheckCircle, Circle, Target, TestTube, ChevronDown, Plus, Stethoscope, FileText, Clock, Hourglass } from 'lucide-react';
import "../../Styles/PC/ProgramTimeline.css";
import { getUserSubscriptionsAPI, getWellnessProfessionalsAPI, getFileByFileIDAPI } from "../../services/pcConfigService";
import BookTestsModal from "../ProgramCoordinator/BookTestsModal";
import BookReviewTestsModal from "../ProgramCoordinator/BookReviewTest";
import BookConsultationModal from "../ProgramCoordinator/BookConsultationModal";
// import cn from '../../lib/utils';





const ProgramTimeline = () => {
    const [subscriptionDetails, setSubscriptionDetails] = useState(null);
    const [expandedPhase, setExpandedPhase] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showBookModal, setShowBookModal] = useState(false);
    const [showBookConsultationModal, setShowBookConsultationModal] = useState(false);
    const [selectedPhaseData, setSelectedPhaseData] = useState(null);
    const [patientId] = useState(sessionStorage.getItem("selectedPatientId") || null);
    const [subscribedDoctors, setSubscribedDoctors] = useState([]);
    const [clinicRegNo, setClinicRegNo] = useState('');
    const [phasedConsultations, setPhasedConsultations] = useState([]);
    const [nextAptOrder, setNextAptOrder] = useState(0);
    const [isReviewTest, setIsReviewTest] = useState(false);
    const [isReviewAppointment, setIsReviewAppointment] = useState(false);
    const [userName, setUserName] = useState('');
    const [userMobile, setUserPhoneNumber] = useState('');
    const [userEmail, setUserEmail] = useState('');
    useEffect(() => {
        fetchUserSubscriptionDetails();
        fetchSubscribedDoctors();
    }, []);

    const fetchUserSubscriptionDetails = async () => {
        try {
            const patientId = sessionStorage.getItem("selectedPatientId");
            const response = await getUserSubscriptionsAPI(patientId);

            if (response?.status === "success") {
                setSubscriptionDetails(response?.subscriptions || null);
                setUserName(response?.subscriptions?.patientInfo?.demographicInfo?.firstName + " " + response?.subscriptions?.patientInfo?.demographicInfo?.lastName || "");
                setUserPhoneNumber(response?.subscriptions?.patientInfo?.phoneNumber || "");
                setUserEmail(response?.subscriptions?.patientInfo?.email || "");
                const currentPhaseNum = response?.subscriptions?.currentPhase || 1;
                setExpandedPhase(currentPhaseNum); // Expand default
                bindConsultationsInSpecificPhase(response?.subscriptions, currentPhaseNum);
            }
        } catch (err) {
            console.error("Subscription Fetch Error:", err);
        } finally {
            setLoading(false);
        }
    };

    const fetchSubscribedDoctors = async () => {
        try {
            const response = await getWellnessProfessionalsAPI();

            if (response) {
                setSubscribedDoctors(response?.professionals || []);
                setClinicRegNo(response?.clinicRegNo || '');
            }
        } catch (err) {
            console.error("Subscribed Doctors Fetch Error:", err);
        }
    };

    const bookConsultation = (phase) => {
        console.log('selectedPhaseData', phase, subscribedDoctors)
        // debugger;
        setIsReviewAppointment(false);
        setShowBookConsultationModal(true);
        setSelectedPhaseData(phase);
    };

    const closeBookTestModal = () => {
        setShowBookModal(false);
        setSelectedPhaseData(null);
        fetchUserSubscriptionDetails();
    };

    const closeBookConsultationModal = () => {
        setShowBookConsultationModal(false);
        setSelectedPhaseData(null);
        fetchUserSubscriptionDetails();
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        return new Date(dateStr).toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
        });
    };

    const toggleAccordion = (phaseNumber, status) => {
        if (status === "PENDING") return;
        setExpandedPhase((prev) =>
            prev === phaseNumber ? null : phaseNumber
        );
        bindConsultationsInSpecificPhase(subscriptionDetails, phaseNumber);
    };

    const bindConsultationsInSpecificPhase = (subscriptionDetails, phaseNumber) => {

        const consultations = subscriptionDetails?.phases[phaseNumber - 1]?.consultations || {};

        const allSessions = [
            ...(consultations.gp?.sessions || []),
            ...(consultations.specialist?.sessions || []),
            ...(consultations.dietician?.sessions || []),
            ...(consultations.fitness?.sessions || []),
        ];

        if (allSessions.length > 0) {
            allSessions.sort((a, b) => new Date(a.date) - new Date(b.date));
            setPhasedConsultations(allSessions);
            const maxOrder = Math.max(...allSessions.map(item => item.order));
            setNextAptOrder(maxOrder + 1);
        } else {
            setPhasedConsultations([]);
            setNextAptOrder(0);
        }
    }

    const shouldDisplayReviewDiagnostics = (phase) => {
        // debugger;
        console.log('phase-----------', phase)
        if (!phase) return false;
        const { diagnostics = [], consultations = {} } = phase;
        /* 1️⃣ All diagnostics completed */
        if (diagnostics.length > 0) {
            const allTestsCompleted =
                diagnostics.length > 0 &&
                diagnostics.every(
                    (test) => test.testStatus === "COMPLETED"
                );

            if (!allTestsCompleted) return false;
        }
        if (consultations.booked !== false) return false;

        /* 3️⃣ screeningSessions must exist and be array */
        const screeningSessions = phase.screeningSessions;

        if (!Array.isArray(screeningSessions)) return false;
        if (screeningSessions?.length === 0) return false; // if no screening sessions, no need for review diagnostics

        /* 4️⃣ Total completed consultations count */
        const totalCompleted =
            (consultations.gp?.completed || 0) +
            (consultations.specialist?.completed || 0) +
            (consultations.dietician?.completed || 0) +
            (consultations.fitness?.completed || 0);

        if (totalCompleted !== screeningSessions?.length) return false;

        return true;


    };

    const hasPendingTests = (diagnostics = []) =>
        diagnostics.some((test) => test.testStatus === "PENDING");

    const shouldShowBookConsultation = (phase) => {
        if (!phase) return false;
        const { diagnostics = [], consultations = {}, screeningSessions } = phase;
        if (diagnostics.length > 0) {
            const hasCompletedTest = diagnostics.some(
                (test) => test.testStatus === "COMPLETED"
            );

            if (!hasCompletedTest) return false;
        } // if no diagnostics, don't show consultation booking



        if (consultations.booked !== false) return false;
        if (screeningSessions?.length > 0) {
            const totalCompleted =
                (consultations.gp?.completed || 0) +
                (consultations.specialist?.completed || 0) +
                (consultations.dietician?.completed || 0) +
                (consultations.fitness?.completed || 0);

            if (Array.isArray(screeningSessions)) {
                return screeningSessions.length > totalCompleted;
            }
        }

        return true;
    };

    const shouldShowBookReviewTestButton = (phase) => {
        // debugger;
        if (!phase) return false;
        const { reviewDiagnostics = [] } = phase;
        if (!shouldDisplayReviewDiagnostics(phase)) return false;
        const hasPendingReviewTest = reviewDiagnostics.some((test) => test.testStatus === "PENDING");
        return hasPendingReviewTest;
    };

    const bookReviewTests = (phase) => {
        const { reviewDiagnostics = [] } = phase;
        const pendingReviewTests = reviewDiagnostics.filter((test) => test.testStatus === "PENDING");
        if (pendingReviewTests.length === 0) return;
        setSelectedPhaseData(phase);
        setIsReviewTest(true);
        setShowBookModal(true);
    }

    const shouldShowBookReviewConsultationButton = (phase) => {
        if (!phase) return false;
        if (phase.phaseStatus == "COMPLETED") return false;
        const { reviewDiagnostics = [], reviewConsultation = {} } = phase;
        const allReviewTestsCompleted = reviewDiagnostics.length > 0 && reviewDiagnostics.every((test) => test.testStatus === "COMPLETED");
        if (!allReviewTestsCompleted) return false;
        if (reviewConsultation.booked !== false) return false;
        return true;
    };

    const bookReviewConsultation = (phase) => {
        setIsReviewAppointment(true);
        setSelectedPhaseData(phase);
        setNextAptOrder(0);
        setShowBookConsultationModal(true);
    }

    const shouldShowReviewConsultations = (phase) => {
        if (!phase) return false;
        const { reviewDiagnostics = [], reviewConsultation = {} } = phase;
        const allReviewTestsCompleted = reviewDiagnostics.length > 0 && reviewDiagnostics.every((test) => test.testStatus === "COMPLETED");
        if (!allReviewTestsCompleted) return false;
        const sessions = reviewConsultation?.gp?.sessions;
        if (!Array.isArray(sessions) || sessions.length === 0) return false;
        return true;
    };
    const getStatusConfig = (test) => {
        if (test.testStatus === 'COMPLETED') {
            return {
                icon: CheckCircle,
                label: 'Results Available',
                color: 'text-success',
                bgColor: 'bg-success/10 border-success/30',
                // badgeVariant: 'default' as const,
            };
        }
        if (test.testStatus === 'IN_PROGRESS') {
            return {
                icon: Hourglass,
                label: 'Awaiting Results',
                color: 'text-warning',
                bgColor: 'bg-warning/10 border-warning/30',
                // badgeVariant: 'secondary' as const,
            };
        }
        if (test.testStatus === 'PENDING') {
            return {
                icon: Clock,
                label: 'Pending',
                color: 'text-muted-foreground',
                bgColor: 'bg-muted/50 border-border',
                // badgeVariant: 'outline' as const,
            };
        }

        return {
            icon: Clock,
            label: 'Pending',
            color: 'text-muted-foreground',
            bgColor: 'bg-muted/50 border-border',
            //   badgeVariant: 'outline' as const,
        };
    };
    const getStatusIcon = (status) => {
        switch (status) {
            case 'COMPLETED':
                return <CheckCircle className="h-4 w-4 text-success" />;
            // case 'in-progress':
            //     return <Clock className="h-4 w-4 text-warning animate-pulse-soft" />;
            default:
                return <Circle className="h-4 w-4 text-muted-foreground" />;
        }
    };
    const clickonViewReport = async (fileID) => {


        if (fileID != undefined) {
            // window.open(onViewReport, '_blank');
            const data = await getFileByFileIDAPI(fileID);
            console.log('File Data:', data);
            if (data && data.fileUrl) {
                window.open(data.fileUrl, '_blank', 'noopener,noreferrer');
            } else {
                console.error('File URL not found in response');
            }
        }
    }

    const RenderTestCard = ({ test, isReview = false }) => {
        const isCompleted = test.testStatus === "COMPLETED";

        const config = getStatusConfig(test);
        const StatusIcon = config.icon;

        return (
            <div className={`timeline-test-card ${test.testStatus.toLowerCase()} `}>
                <div className="test-card-content">
                    <div className="test-icon-container">
                        <StatusIcon className={'h-4 w-4 text-success ${config.color}'} />

                    </div>
                    <div className="test-details">
                        <div className="test-name">{test.testName}</div>


                        <div className="test-result-badge">
                            <span className={`result-pill ${test.testStatus.toLowerCase()}`}>  {test.testStatus}</span>
                            <span className="result-date">{test.completedDate ? formatDate(test.completedDate) : formatDate(new Date())}</span>
                        </div>

                        {/* <div className={`test-status-text ${test.testStatus.toLowerCase()}`}>
                                {test.testStatus}
                            </div> */}

                    </div>
                    <div className="test-action">
                        {test.fileID && (
                            <button
                                className="icon-btn"
                                onClick={() => clickonViewReport(test.fileID)}
                                title="View Report"
                            >
                                <FileText className="icon" />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    const RenderConsultationCard = ({ consultation }) => {
        const isCompleted = consultation.status === "COMPLETED";
        const consDate = consultation.date ? formatDate(consultation.date) : "";

        return (
            <div className={`timeline-consultation-card ${isCompleted ? 'completed' : ''}`}>
                <div className="consultation-content">
                    <div className="consultation-icon-container">
                        {/* {isCompleted ? <CheckCircle className="consultation-icon" /> : <div className="empty-circle"></div>} */}
                        {getStatusIcon(consultation.status)}
                    </div>
                    <div className="consultation-details">
                        <div className="doc-name">Dr. {consultation.doctorName}</div>
                        <div className="doc-info">
                            <span className="doc-speciality">{consultation.speciality}</span>
                            {consDate && <span className="doc-date">{consDate}</span>}
                        </div>
                    </div>
                    <div className="consultation-action">
                        {isCompleted && (
                            <button className="icon-btn" onClick={() => {
                                if (consultation.prescriptionBase64) {
                                    const base64 = consultation.prescriptionBase64.replace(/^data:application\/pdf;base64,/, '');
                                    const byteCharacters = atob(base64);
                                    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
                                    const byteArray = new Uint8Array(byteNumbers);
                                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                                    const blobUrl = URL.createObjectURL(blob);
                                    window.open(blobUrl, '_blank');
                                }
                            }}>
                                <FileText className="icon" />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    if (loading) return <div className="timeline-loading">Loading...</div>;
    // if (!subscriptionDetails)
    //     return <div className="timeline-empty">No subscription found</div>;

    return (
        <div className="timeline-container">
            {/* <h2 className="timeline-title">Program Timeline</h2> */}
            <div className="col-md-12">
                <div className="wellness-container">
                    <div className="header-section">
                        <h2 className="main-title">{userName}'s Wellness Journey</h2>
                        <div className="user-contact-details">
                            <p>Mob: +91-{userMobile}</p>
                            <p>Email: {userEmail}</p>
                        </div>

                        {/* <p className="subtitle">Track your progress through all phases</p> */}
                    </div>

                    <div className="progress-card">
                        <div className="progress-header">
                            <div>
                                <p className="overall-text">Overall Progress</p>
                                <h3 className="phase-text">
                                    Phase {subscriptionDetails?.currentPhase} of 4
                                </h3>
                            </div>

                            <div className="percentage-badge">
                                {subscriptionDetails?.progressPercentage}%
                            </div>
                        </div>

                        <div className="progress-bar-container">
                            <div
                                className="progress-bar-fill"
                                style={{ width: `${subscriptionDetails?.progressPercentage}%` }}
                            />
                        </div>


                    </div>
                </div>
            </div>
            {subscriptionDetails?.phases?.map((phase) => {
                const isExpanded = expandedPhase === phase.phaseNumber;
                const isPending = phase.phaseStatus === "PENDING";

                return (



                    <div
                        key={phase._id}
                        className={`phase-card ${isPending ? "pending-phase" : ""}`}
                    >
                        {/* Accordion Header */}
                        <div
                            className={`phase-header ${isExpanded ? "expanded" : ""}`}
                            onClick={() =>
                                toggleAccordion(
                                    phase.phaseNumber,
                                    phase.phaseStatus
                                )
                            }
                        >
                            <div className="phase-header-left">
                                <div className="phase-number-circle">{phase.phaseNumber}</div>
                                <div className="phase-title-container">
                                    <h3>Phase {phase.phaseNumber}: {phase.phaseName}</h3>
                                    {isExpanded && <div className="phase-title-underline"></div>}
                                </div>
                            </div>

                            <div className="phase-header-right">
                                <span
                                    className={`phase-status-badge ${phase.phaseStatus.toLowerCase().replace("_", "-")}`}
                                >
                                    {phase.phaseStatus.replace("_", " ")}
                                </span>
                                {!isPending && (
                                    <span className="accordion-icon">
                                        {isExpanded ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
                                        ) : (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                                        )}
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* Accordion Content */}
                        {isExpanded && (
                            <div className="phase-content">
                                <div className="phase-grid">

                                    {/* Tests Section */}
                                    <div className="section">
                                        <div className="section-title-row">
                                            {/* <svg className="section-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> */}
                                            <TestTube className="h-4 w-4" />
                                            <h4>Diagnostic Tests</h4>
                                        </div>

                                        {phase.diagnostics?.length > 0 ? (
                                            <div className="tests-list">
                                                {phase.diagnostics.map((test) => (
                                                    <RenderTestCard key={test._id} test={test} />
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="empty-text">No tests available</div>
                                        )}
                                        {hasPendingTests(phase.diagnostics) && (
                                            <button
                                                className="book-btn"
                                                onClick={() => {
                                                    const { consultations, ...phaseWithoutConsultations } = phase;
                                                    setSelectedPhaseData({
                                                        ...phaseWithoutConsultations,
                                                        diagnostics: phase.diagnostics.filter((test) => test.testStatus === "PENDING"),
                                                    });
                                                    setShowBookModal(true);
                                                }}
                                            >
                                                + Book Pending Tests
                                            </button>
                                        )}
                                        {shouldDisplayReviewDiagnostics(phase) &&
                                            phase.reviewDiagnostics &&
                                            phase.reviewDiagnostics.length > 0 && (
                                                <>
                                                    <div className="review-separator">Review Tests</div>
                                                    {phase.reviewDiagnostics.map((reviewTest) => (
                                                        <RenderTestCard key={reviewTest._id} test={reviewTest} isReview={true} />
                                                    ))}
                                                </>
                                            )}
                                        {shouldShowBookReviewTestButton(phase) && (
                                            <button
                                                className="book-btn"
                                                onClick={() => { bookReviewTests(phase) }}
                                            >
                                                + Book Review Tests
                                            </button>
                                        )}
                                    </div>


                                    {/* Consultations Section */}
                                    <div className="section">
                                        <div className="section-title-row">
                                            {/* <svg className="section-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.8 2.3A.3.3 0 0 0 5 2.5h14a.3.3 0 0 0 .2-.2l.7-1.4a.3.3 0 0 0-.2-.4H4.3a.3.3 0 0 0-.2.4zm1.5 1.5a.3.3 0 0 0 .2.2h10a.3.3 0 0 0 .2-.2l-.6-1h-9l-.8 1zM2 9v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2zm18 12H4V9h16v12z"></path><path d="M8 12h8"></path><path d="M8 16h8"></path></svg> */}
                                            <Stethoscope className="h-4 w-4" />
                                            <h4>Consultations</h4>
                                        </div>
                                        <div className="consultations-list">
                                            {phasedConsultations.map((consultation, index) => (
                                                <RenderConsultationCard key={index} consultation={consultation} />
                                            ))}


                                        </div>

                                        {shouldShowBookConsultation(phase) && (
                                            <div className="book-consultation-btn-row">
                                                <button className="book-cons-btn-full" onClick={() => bookConsultation(phase)}>
                                                    + Book Consultation
                                                </button>
                                            </div>
                                        )}
                                        {
                                            shouldShowReviewConsultations(phase) && (
                                                <div className='consultation-list'>
                                                    <h3>Review Consultations</h3>
                                                    {phase?.reviewConsultation?.gp?.sessions?.map((consultation, index) => (
                                                        <RenderConsultationCard key={`review-${index}`} consultation={consultation} />

                                                    ))}
                                                </div>
                                            )
                                        }
                                        {shouldShowBookReviewConsultationButton(phase) && (
                                            <div className="book-review-consultation-btn-row">
                                                <button className="book-cons-btn-full" onClick={() => bookReviewConsultation(phase)}>
                                                    + Book Review Consultation
                                                </button>
                                            </div>
                                        )}
                                        {phasedConsultations.length === 0 && !shouldShowReviewConsultations(phase) && !shouldShowBookConsultation(phase) && (
                                            <div className="empty-text">No consultations available</div>
                                        )}
                                    </div>

                                    {/* Goals Section */}
                                    <div className="section">
                                        <div className="section-title-row">
                                            {/* <svg className="section-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg> */}
                                            <Target className="h-4 w-4" />
                                            <h4>Goals</h4>
                                        </div>
                                        {phase.goals?.length > 0 ? (
                                            <div className="goals-list">
                                                {phase.goals.map(
                                                    (goal, index) => (
                                                        <div key={goal._id} className="goal-card-simple">
                                                            <span className="goal-text">{goal.goal}</span>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        ) : (
                                            <div className="empty-text">
                                                No goals set
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>
                        )}
                    </div>

                );
            })}

            {showBookModal && selectedPhaseData && (
                <BookTestsModal
                    phaseData={selectedPhaseData}
                    patientId={patientId}
                    patientInfo={subscriptionDetails?.patientInfo}
                    isReviewTest={isReviewTest}
                    onClose={() => closeBookTestModal()}
                />
            )}
            {
                showBookConsultationModal && selectedPhaseData && (
                    <BookConsultationModal
                        phaseData={selectedPhaseData}
                        doctorsList={subscribedDoctors}
                        patientId={patientId}
                        clinicRegNo={clinicRegNo}
                        patientInfo={subscriptionDetails?.patientInfo}
                        nextAptOrder={nextAptOrder}
                        isReviewAppointment={isReviewAppointment}
                        onClose={() => closeBookConsultationModal()}
                    />
                )
            }
        </div>
    );
};

export default ProgramTimeline;
